import {PlantViewOption} from '@hconnect/common/consts'
import {ErrorMessage, Loader} from '@hconnect/uikit/src/lib2'
import {Box} from '@mui/material'
import {isEmpty} from 'lodash'
import React, {useMemo} from 'react'
import {Trans, useTranslation} from 'react-i18next'
import {NavigateFunction, useNavigate} from 'react-router'

import {LocationTreeTable, PlantTable} from '../components'
import {FEATURE_NAMESPACE} from '../consts'
import {useAllLocationsStats, usePomNavigation} from '../hooks'
import {extractPlantLocations, mapToDashboardEntries, getPlantRedirectData} from '../utils'

export const PlantsOverviewTableContainer: React.FC<{plantView: PlantViewOption}> = ({
  plantView
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const navigate: NavigateFunction = useNavigate()
  const nav = usePomNavigation()
  const {data, isError, isLoading} = useAllLocationsStats()
  const hierarchicalData = useMemo(() => mapToDashboardEntries(data ?? []), [data])
  const flatData = useMemo(() => extractPlantLocations(data ?? []), [data])
  const {showPlantOverview, redirectPlantId} = useMemo(() => getPlantRedirectData(data), [data])

  if (isLoading) {
    return <Loader />
  }

  if (isError) {
    return <ErrorMessage>{t('errors.plantsNotFetched')}</ErrorMessage>
  }

  if (isEmpty(data)) {
    return (
      <ErrorMessage>
        <Trans i18nKey={'errors.noPlantDataAvailable'} />
      </ErrorMessage>
    )
  }

  if (!showPlantOverview && redirectPlantId) {
    void navigate(nav.buildDashboardPath(redirectPlantId))
  }

  // Show the component that corresponds to the plant view option
  // It would have been shorter to use a ternary operator, but this causes re-rendering of larger swathes of the screen.
  // Therefore, the components not needed are just made invisible.
  return (
    <>
      <Box display={plantView === 'plantList' ? 'initial' : 'none'}>
        <PlantTable plants={flatData} />
      </Box>
      <Box display={plantView === 'regionalStructure' ? 'initial' : 'none'}>
        <LocationTreeTable entries={hierarchicalData} />
      </Box>
    </>
  )
}
